import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';
import { PayloadService } from '../payload/payload.service';


import { tap, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AccountsService {

    constructor(
        private http: HttpClient,
        public payloadService: PayloadService
    ) { }

    infos(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "accounts/infos", { 
                        "payload": payload 
                    });
                }
            )
        )
        
    }
}
